export const usersListData = {
  total: 10,
  limit: 10,
  skip: 0,
  data: [
    {
      id: 370,
      email: 'susan+stg56@bmiq.com',
      newEmail: null,
      isVerifiedNewEmail: false,
      oldActivatedEmail: null,
      isVerified: false,
      verifiedDate: '2020-11-19T23:24:23.553Z',
      verifyToken: '43eab05a20e1bb3d05600af8b37e12',
      verifyExpires: '2020-12-05T07:01:25.478Z',
      resetToken: null,
      resetExpires: null,
      lastIpAddress: null,
      currentIpAddress: null,
      timezone: null,
      accountsExpired: false,
      isWorkFactorChanged: false,
      accountLocked: false,
      credentialsExpired: false,
      accountEnabled: true,
      type: 'organization-admin',
      isUserReminded: 'reminded-7',
      loginAttempts: 0,
      userIdentifier: null,
      deduUserId: null,
      bmiqUserId: null,
      migratedAt: null,
      migrateMessageShowed: false,
      isSubscribed: true,
      accountAccessToken: '43eab05a20e1bb3d05600af8b37e12',
      twoFaWaiting: false,
      authSecret: null,
      authEnabled: false,
      authType: null,
      backupCodes: null,
      allowedFeatures: null,
      isTestUser: false,
      isSmsNotificationsEnabled: false,
      isPushNotificationEnabled: true,
      isMobileVerified: false,
      mobileVerificationCodeExpires: null,
      passwordLastUpdate: null,
      lastLogin: null,
      createdAt: '2020-11-13T22:05:30.194Z',
      updatedAt: '2020-11-21T07:01:26.447Z',
      createdBy: 1,
      updatedBy: 336,
      user_detail: {
        fullName: 'Harry Thurman',
        id: 682,
        firstName: 'Harry',
        lastName: 'Thurman',
        gender: null,
        birthDate: null,
        city: null,
        userId: 370,
        addressLine1: null,
        addressLine2: null,
        mobilePhone: null,
        homePhone: null,
        extension: null,
        termId: null,
        accountInfoStatus: 1,
        createdAt: '2020-11-13T22:05:30.231Z',
        updatedAt: '2020-11-13T22:05:30.231Z',
        createdBy: 1,
        updatedBy: 1,
        countryId: null,
        stateId: null,
        zipCodeId: null,
      },
      organizations_users: [
        {
          id: 24,
          userId: 370,
          organizationId: 14,
          roleId: 3,
          createdAt: '2020-11-13T22:05:30.270Z',
          updatedAt: '2020-11-13T22:05:30.270Z',
          createdBy: 1,
          updatedBy: 1,
          organization: {
            id: 14,
            name: 'CWCC Wellness Program',
            active: true,
            siteId: 1413,
            address: null,
            city: null,
            subdomain: null,
            useReverseProxy: false,
            timezone: 'America/New_York',
            authEnabled: false,
            passwordExpiresAfter: null,
            vpnEnabled: false,
            vpnSettings: null,
            createdAt: '2020-11-13T21:35:38.557Z',
            updatedAt: '2020-11-30T22:25:47.627Z',
            createdBy: 1,
            updatedBy: 1,
            ownerId: 370,
            countryId: null,
            stateId: null,
            zipCodeId: null,
          },
        },
      ],
    },
    {
      id: 369,
      email: 'susan+stg55@bmiq.com',
      newEmail: null,
      isVerifiedNewEmail: false,
      oldActivatedEmail: null,
      isVerified: false,
      verifiedDate: null,
      verifyToken: '6482767e956399cc09d7fb8b8106d8',
      verifyExpires: '2020-12-05T07:01:25.478Z',
      resetToken: null,
      resetExpires: null,
      lastIpAddress: null,
      currentIpAddress: null,
      timezone: null,
      accountsExpired: false,
      isWorkFactorChanged: false,
      accountLocked: false,
      credentialsExpired: false,
      accountEnabled: true,
      type: 'organization-admin',
      isUserReminded: 'reminded-7',
      loginAttempts: 0,
      userIdentifier: null,
      deduUserId: null,
      bmiqUserId: null,
      migratedAt: null,
      migrateMessageShowed: false,
      isSubscribed: true,
      accountAccessToken: '6482767e956399cc09d7fb8b8106d8',
      twoFaWaiting: false,
      authSecret: {},
      authEnabled: true,
      authType: null,
      backupCodes: null,
      allowedFeatures: null,
      isTestUser: false,
      isSmsNotificationsEnabled: false,
      isPushNotificationEnabled: true,
      isMobileVerified: false,
      mobileVerificationCodeExpires: null,
      passwordLastUpdate: null,
      lastLogin: null,
      createdAt: '2020-11-13T21:40:07.230Z',
      updatedAt: '2020-11-21T07:01:26.447Z',
      createdBy: 1,
      updatedBy: 336,
      user_detail: {
        fullName: 'Fiona Mellonton',
        id: 681,
        firstName: 'Fiona',
        lastName: 'Mellonton',
        gender: null,
        birthDate: null,
        city: null,
        userId: 369,
        addressLine1: null,
        addressLine2: null,
        mobilePhone: null,
        homePhone: null,
        extension: null,
        termId: null,
        accountInfoStatus: 1,
        createdAt: '2020-11-13T21:40:07.262Z',
        updatedAt: '2020-11-13T21:40:07.262Z',
        createdBy: 1,
        updatedBy: 1,
        countryId: null,
        stateId: null,
        zipCodeId: null,
      },
      organizations_users: [
        {
          id: 23,
          userId: 369,
          organizationId: 6,
          roleId: 3,
          createdAt: '2020-11-13T21:40:07.288Z',
          updatedAt: '2020-11-13T21:40:07.288Z',
          createdBy: 1,
          updatedBy: 1,
          organization: {
            id: 6,
            name: 'JIB Wellness Program',
            active: true,
            siteId: 1411,
            address: null,
            city: null,
            subdomain: null,
            useReverseProxy: false,
            timezone: 'America/New_York',
            authEnabled: false,
            passwordExpiresAfter: null,
            vpnEnabled: false,
            vpnSettings: null,
            createdAt: '2020-03-03T08:11:49.277Z',
            updatedAt: '2020-11-13T21:34:14.054Z',
            createdBy: null,
            updatedBy: 1,
            ownerId: 132,
            countryId: null,
            stateId: null,
            zipCodeId: null,
          },
        },
      ],
    },
    {
      id: 371,
      email: 'clare+stg150@bmiq.com',
      newEmail: null,
      isVerifiedNewEmail: false,
      oldActivatedEmail: null,
      isVerified: true,
      verifiedDate: '2020-11-19T23:24:23.553Z',
      verifyToken: null,
      verifyExpires: null,
      resetToken: null,
      resetExpires: null,
      lastIpAddress: null,
      currentIpAddress: null,
      timezone: null,
      accountsExpired: false,
      isWorkFactorChanged: true,
      accountLocked: false,
      credentialsExpired: false,
      accountEnabled: true,
      type: 'organization-admin',
      isUserReminded: 'reminded-2',
      loginAttempts: 0,
      userIdentifier: '361d78796638453a09f03b8ee52853cdc96fdcfb_1605828264452@intellihealth.com',
      deduUserId: 365023,
      bmiqUserId: null,
      migratedAt: null,
      migrateMessageShowed: false,
      isSubscribed: true,
      accountAccessToken: '3ef93b1f41aee74426507f847e9545',
      twoFaWaiting: false,
      authSecret: null,
      authEnabled: true,
      authType: null,
      backupCodes: null,
      allowedFeatures: null,
      isTestUser: false,
      isSmsNotificationsEnabled: false,
      isPushNotificationEnabled: true,
      isMobileVerified: false,
      mobileVerificationCodeExpires: null,
      passwordLastUpdate: null,
      lastLogin: null,
      createdAt: '2020-11-13T22:05:38.855Z',
      updatedAt: '2020-11-19T23:24:26.434Z',
      createdBy: 1,
      updatedBy: 371,
      user_detail: {
        fullName: 'Jasmine Franklin',
        id: 683,
        firstName: 'Jasmine',
        lastName: 'Franklin',
        gender: null,
        birthDate: null,
        city: null,
        userId: 371,
        addressLine1: null,
        addressLine2: null,
        mobilePhone: null,
        homePhone: null,
        extension: null,
        termId: 1,
        accountInfoStatus: 1,
        createdAt: '2020-11-13T22:05:38.868Z',
        updatedAt: '2020-11-19T23:24:24.470Z',
        createdBy: 1,
        updatedBy: 1,
        countryId: null,
        stateId: null,
        zipCodeId: null,
      },
      organizations_users: [
        {
          id: 25,
          userId: 371,
          organizationId: 17,
          roleId: 3,
          createdAt: '2020-11-13T22:05:38.889Z',
          updatedAt: '2020-11-13T22:05:38.889Z',
          createdBy: 1,
          updatedBy: 1,
          organization: {
            id: 17,
            name: 'Overview Sharing Wellness Program',
            active: true,
            siteId: 1410,
            address: null,
            city: null,
            subdomain: null,
            useReverseProxy: false,
            timezone: 'America/New_York',
            authEnabled: false,
            passwordExpiresAfter: null,
            vpnEnabled: false,
            vpnSettings: null,
            createdAt: '2020-11-13T21:37:07.149Z',
            updatedAt: '2020-11-13T22:05:38.884Z',
            createdBy: 1,
            updatedBy: 1,
            ownerId: 371,
            countryId: null,
            stateId: null,
            zipCodeId: null,
          },
        },
      ],
    },
  ],
};
